import { render, staticRenderFns } from "./createWxFuwuOrder.vue?vue&type=template&id=6bc6b3d6&scoped=true"
import script from "./createWxFuwuOrder.vue?vue&type=script&lang=js"
export * from "./createWxFuwuOrder.vue?vue&type=script&lang=js"
import style0 from "./createWxFuwuOrder.vue?vue&type=style&index=0&id=6bc6b3d6&prod&scoped=true&lang=css"
import style1 from "./createWxFuwuOrder.vue?vue&type=style&index=1&id=6bc6b3d6&prod&lang=css"
import style2 from "./createWxFuwuOrder.vue?vue&type=style&index=2&id=6bc6b3d6&prod&scoped=true&lang=scss"
import style3 from "./createWxFuwuOrder.vue?vue&type=style&index=3&id=6bc6b3d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6b3d6",
  null
  
)

export default component.exports